import { IDictionary } from '~utilities/IDictionary';
import CodeTypeEnum from './CodeTypeEnum';

const codeTypeLabels: IDictionary<string> = {
    [CodeTypeEnum.Code]: 'NCCP Regulated',
    [CodeTypeEnum.NonCode]: 'Non NCCP Regulated',
};

export default codeTypeLabels;